import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

const authHeaders = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

export async function getSettings(accessToken) {
    const res = await axios.get(`${API_URL}/api/settings`, { headers: authHeaders(accessToken) });
    return res.data;
}

export async function updateSettings(accessToken, data) {
    const res = await axios.put(`${API_URL}/api/settings`, data, { headers: authHeaders(accessToken) });
    return res.data;
}
